var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path, _path2, _path3, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _path4, _path5, _path6, _polygon17, _polygon18, _polygon19, _polygon20, _path7, _path8, _path9, _rect13, _path10, _path11, _polygon21, _ellipse, _ellipse2, _rect14, _rect15, _path12, _rect16, _g, _path13, _path14, _path15, _path16, _circle, _circle2, _circle3, _path17, _path18, _path19, _path20, _circle4, _circle5, _circle6, _path21, _path22, _path23, _circle7, _circle8, _circle9, _path24, _path25, _path26, _path27, _circle10, _circle11, _circle12, _circle13, _circle14, _path28, _path29, _path30, _circle15, _circle16, _circle17, _path31, _path32, _rect17, _path33, _path34, _circle18, _path35, _path36, _path37, _path38, _path39, _g2, _g3, _g4, _g5, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _ellipse3, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _polygon22, _polygon23, _rect18, _rect19, _rect20, _rect21, _rect22, _path81, _path82, _ellipse4, _ellipse5, _path83, _path84, _path85;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.39,451.21S-9.71,372.52,71.14,182.83c0,0,56-145.24,256-145.06,0,0,37.31-2.5,88,3,0,0,47.31,3,91-9,0,0,176.05-43.88,250.66,52.86,0,0,43.77,43.05,57.7,145.18,0,0,23,118.24-111.35,203.93,0,0-142,97.66-367,78.71C336.25,512.46,229.27,500.66,145.39,451.21Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.27,
    y: 166.11,
    width: 98.61,
    height: 152.71,
    fill: "#fddfd2"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.75,
    y: 3.94,
    width: 798.46,
    height: 522.31,
    fill: "#243E59"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.75,
    y: 3.94,
    width: 798.46,
    height: 522.31,
    fill: "#fff",
    opacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 94.31,
    y: 73.24,
    width: 231.17,
    height: 286.38,
    fill: "#f0f5fc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 100.67,
    y: 73.24,
    width: 217.4,
    height: 282.36,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 255.9,
    y: 73.24,
    width: 5.86,
    height: 286.38,
    fill: "#f9e4de"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 174.07,
    y: 73.24,
    width: 5.86,
    height: 286.38,
    fill: "#f9e4de"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 96.13,
    y: 133.13,
    width: 228.94,
    height: 6.9,
    fill: "#f9e4de"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 514.67,
    y: 73.24,
    width: 231.17,
    height: 286.38,
    fill: "#f0f5fc"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 521.03,
    y: 73.24,
    width: 217.4,
    height: 282.36,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 676.25,
    y: 73.24,
    width: 5.86,
    height: 286.38,
    fill: "#f9e4de"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 594.43,
    y: 73.24,
    width: 5.86,
    height: 286.38,
    fill: "#f9e4de"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 516.49,
    y: 133.13,
    width: 228.94,
    height: 6.9,
    fill: "#f9e4de"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "426.83 216.74 415.29 216.74 415.29 217.83 426.83 229.4 426.83 216.74",
    fill: "#EC1C24"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "415.29 217.83 415.29 291.2 426.83 291.2 426.83 229.4 415.29 217.83",
    fill: "#EC1C24"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "438.08 216.74 426.83 216.74 426.83 229.4 438.08 240.68 438.08 216.74",
    fill: "#EC1C24"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "426.83 229.4 426.83 291.2 438.08 291.2 438.08 240.68 426.83 229.4",
    fill: "#EC1C24"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "417.66 220.21 417.66 271.33 426.83 271.33 426.83 229.4 417.66 220.21",
    fill: "#f5f6f6"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "426.83 220 417.66 220 417.66 220.21 426.83 229.4 426.83 220",
    fill: "#fff"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "435.71 220 426.83 220 426.83 229.4 435.71 238.3 435.71 220",
    fill: "#ecedee"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "426.83 229.4 426.83 271.33 435.71 271.33 435.71 238.3 426.83 229.4",
    fill: "#e2e3e4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M426.69,286a4.86,4.86,0,0,1,0-9.72h.17a4.86,4.86,0,0,1,0,9.71h-.17Z",
    fill: "#e2e3e4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M422.56,281.13a4.13,4.13,0,0,0,4.13,4.14h.14V277h-.14A4.13,4.13,0,0,0,422.56,281.13Z",
    fill: "#f5f6f6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M426.83,277v8.25a4.13,4.13,0,0,0,0-8.25Z",
    fill: "#e2e3e4"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.62 216.74 438.08 216.74 438.08 240.68 449.62 252.24 449.62 216.74",
    fill: "#243E59"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "438.08 240.68 438.08 291.2 449.62 291.2 449.62 252.24 438.08 240.68",
    fill: "#243E59"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "460.87 216.74 449.62 216.74 449.62 252.24 460.87 263.52 460.87 216.74",
    fill: "#243E59"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.62 252.24 449.62 291.2 460.87 291.2 460.87 263.52 449.62 252.24",
    fill: "#243E59"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.62 220 440.45 220 440.45 243.05 449.62 252.24 449.62 220",
    fill: "#fff"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "440.45 243.05 440.45 271.33 449.62 271.33 449.62 252.24 440.45 243.05",
    fill: "#f5f6f6"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "458.5 220 449.62 220 449.62 252.24 458.5 261.14 458.5 220",
    fill: "#ecedee"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.62 252.24 449.62 271.33 458.5 271.33 458.5 261.14 449.62 252.24",
    fill: "#e2e3e4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M449.47,286a4.86,4.86,0,0,1,0-9.72h.18a4.86,4.86,0,0,1,0,9.71h-.18Z",
    fill: "#e2e3e4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M445.35,281.13a4.12,4.12,0,0,0,4.12,4.14h.15V277h-.15A4.12,4.12,0,0,0,445.35,281.13Z",
    fill: "#f5f6f6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M449.62,277v8.25a4.13,4.13,0,0,0,0-8.25Z",
    fill: "#e2e3e4"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "395.6 213.59 378.94 286.15 390.19 288.74 406.85 216.18 395.6 213.59",
    fill: "#243E59"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "417.81 218.71 406.85 216.18 390.19 288.74 401.15 291.27 417.81 218.71",
    fill: "#243E59"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "397.18 217.3 385.69 267.31 394.64 269.38 406.12 219.36 397.18 217.3",
    fill: "#fff"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "414.77 221.36 406.12 219.36 394.64 269.38 403.29 271.37 414.77 221.36",
    fill: "#e6e7e8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M392.3,283.75a4.7,4.7,0,0,1-.92-.08h0l-.14,0a4.86,4.86,0,0,1,1.08-9.6,5,5,0,0,1,1.09.12l.14,0h0a4.85,4.85,0,0,1-1.25,9.54Z",
    fill: "#e2e3e4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M393.22,274.87a4.13,4.13,0,0,0-1.85,8.06l.15,0,1.84-8Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M396.32,279.83a4.13,4.13,0,0,0-3-4.92l-1.84,8A4.14,4.14,0,0,0,396.32,279.83Z",
    fill: "#e6e7e8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 368.98,
    y: 291.6,
    width: 103.38,
    height: 8.42,
    fill: "#f9c4b7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.17,100.39a39.75,39.75,0,1,0,39.65,39.75A39.7,39.7,0,0,0,419.17,100.39Z",
    fill: "#a7a9ac",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M461.83,138.63a39.66,39.66,0,1,1-39.65-39.75A39.71,39.71,0,0,1,461.83,138.63Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M454.27,138.63a32.1,32.1,0,1,1-32.09-32.18A32.14,32.14,0,0,1,454.27,138.63Z",
    fill: "#f9e4de"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.94 125.3 424.48 141.25 403.02 132.32 401.64 135.63 422.74 144.41 423.12 144.57 423.31 144.43 447.04 126.79 445.94 125.3",
    fill: "#fcd6ca"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 412.67,
    cy: 624.72,
    rx: 318.08,
    ry: 36.32,
    fill: "#243E59"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 412.67,
    cy: 624.72,
    rx: 318.08,
    ry: 36.32,
    fill: "#fff",
    opacity: 0.7
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 284.14,
    y: 106.77,
    width: 364.29,
    height: 513.99,
    rx: 10.93,
    fill: "#243E59"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 299.52,
    y: 119.7,
    width: 335.41,
    height: 477.47,
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M267.06,573.07s-.41,3.1,2.94,11.32a59.69,59.69,0,0,0,3.44,6.94,27.83,27.83,0,0,1,3.67,16.26s-2.68,19.84,7,17.26c0,0,4.14.55,10.05-13.83a44.09,44.09,0,0,0,3.24-18.27L296.89,577a62.71,62.71,0,0,1,.45-9.68c.68-5.79.5-16.13-9.95-14.64,0,0-5.67,1.29-8.48,0Z",
    fill: "#EC1C24"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 334.27,
    y: 166.11,
    width: 98.61,
    height: 152.71,
    fill: "#fddfd2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.72,450.11l-3,2.54a10.6,10.6,0,0,1-4.72,1.52h-8.31c-1.72,0-1-1.78-1-1.78a.83.83,0,0,0,.8.58h7.4c3.45.41,7.76-3.43,8.79-4.4A1.39,1.39,0,0,0,372,448c0-.1.07-.22.1-.33A2.4,2.4,0,0,1,371.72,450.11Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.25,429.1v6.13a4.36,4.36,0,0,0-.79,2.83s4.32-1.15,7,1.23h1.76s.18-8.31,1.06-9.93Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.22,429.08v6.14a4.36,4.36,0,0,1,.79,2.83s-4.32-1.15-7,1.23h-1.76s-.18-8.31-1.06-9.93Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.11,281s-6.18,7.71-9.28,28.06a85.22,85.22,0,0,0-.89,15.64L359.42,429l17.69.51,6.61-65.92,6.14,66.36H408.3L411.15,359l.8-40.94s-.41-24.29-10.74-37.94l-7.08-6.55-21.9,5.83Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.39,217.17s-3.1-1.43-3.22-8.47c0,0-.36-1.07.72-8.47,0,0,1.19-6.08,1.9-10.25,0,0,1.2-9.43,10.26-11.69a23.08,23.08,0,0,1,14.63.61,11.06,11.06,0,0,1,4.11,2.91c2,2.3,4.84,6.81,5.36,14.49v15.15s.71,4.41-2.87,6.2a10.46,10.46,0,0,0,.24-3s-1.55,4.29-4.65,2.5a4.81,4.81,0,0,1-3.22.48l-13.9-.48A16.19,16.19,0,0,0,370,217a1.66,1.66,0,0,1-1.56-.51,6.26,6.26,0,0,1-1.49-2.8A10.61,10.61,0,0,0,367.39,217.17Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.13,203.3c0,.73.05,1.46.06,2.18s0,1.45.07,2.17.07,1.43.15,2.15a13,13,0,0,0,.39,2.12,6.59,6.59,0,0,1-.75-2.07,12.36,12.36,0,0,1-.26-2.18A17.29,17.29,0,0,1,366.13,203.3Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.35,216.38c.11-.55.16-1.1.22-1.64l.15-1.65c0-.55.1-1.1.17-1.65a15.62,15.62,0,0,1,.24-1.65,14.43,14.43,0,0,1,.06,3.35,13.62,13.62,0,0,1-.26,1.66A5.37,5.37,0,0,1,393.35,216.38Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.13,
    y: 203.3,
    width: 0.64,
    height: 6.49,
    fill: "#243E59"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 371.38,
    cy: 210.98,
    rx: 1.14,
    ry: 2.1,
    fill: "#243E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.78,214v5.31l-7,4.69-6.56-4.86v-4.74a9.68,9.68,0,0,0,6.56,2.74A9.88,9.88,0,0,0,390.78,214Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.13,222.86h0l-7.26,7-3.07-5.11-3.21,5.11-7-7.46,1.76-2.51a1.38,1.38,0,0,1,1.93-.76l6.56,4.86,7-4.69C391.86,218.62,394.13,222.86,394.13,222.86Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.87,281a30.21,30.21,0,0,0-4.32,6.35c-1.08,2.77-5.47,3.11-5.47,3.11l-1.82,1.29a.61.61,0,0,1-.89-.18l-5.25-8.85a1.18,1.18,0,0,1,.1-1.34l.49-.58a46.62,46.62,0,0,1,1.19-5.69,5.79,5.79,0,0,0,.21-2,3.5,3.5,0,0,1,.58-2,5.77,5.77,0,0,0-.13-1.72.46.46,0,0,0-.88,0,26,26,0,0,1-3.75,8.65,4.54,4.54,0,0,1-3.76,2.06,19.64,19.64,0,0,1-5.27-.9,4.59,4.59,0,0,0-1.77-.16C384,280.28,365.48,281,365.48,281l-.67.22c.22,1.35-.68,1.69-.68,1.69l-5.63,3.14a6.77,6.77,0,0,1-7.41,0L346.37,284c-2.7-1.24-2.82-6.75-2.82-6.75-1-11,5.85-35.76,5.85-35.76A15.3,15.3,0,0,1,360,228.06l13.57-5.62,7,7.46,3.21-5.11,3.07,5.11,7.26-7h0l15.53,7c8.24,3.12,11.08,15.59,11.08,15.59,5.61,10.34,7.09,26.08,7.09,26.08A14.25,14.25,0,0,1,425.87,281Z",
    fill: "#243E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,236.68c.81,1.5,1.57,3,2.3,4.57s1.42,3.1,2.06,4.68,1.24,3.19,1.74,4.82a21.26,21.26,0,0,1,.63,2.5,7.45,7.45,0,0,1,.11,2.63v0c-.31,2.21-.63,4.42-1,6.62s-.69,4.4-1.07,6.6c.24-2.22.49-4.43.77-6.65s.55-4.42.85-6.63h0a7.28,7.28,0,0,0-.13-2.45c-.17-.82-.38-1.64-.62-2.45-.48-1.63-1.06-3.23-1.67-4.81C358.73,242.91,357.37,239.79,356,236.68Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.26,241.84c-.08-1.27-.12-2.54-.15-3.8s-.05-2.54-.06-3.8v-3.8c0-.63,0-1.27,0-1.9s0-1.27,0-1.9a30,30,0,0,1,.39,3.79c.08,1.27.11,2.54.12,3.8s0,2.54,0,3.81S384.37,240.57,384.26,241.84Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.21,278.48c.58-.77,1.13-1.56,1.68-2.34s1.06-1.59,1.56-2.41,1-1.64,1.42-2.48.86-1.72,1.26-2.59a16.15,16.15,0,0,1-.92,2.75,21,21,0,0,1-1.36,2.57A21.32,21.32,0,0,1,401.21,278.48Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.68,262.14a18.45,18.45,0,0,1,.11-6.46,19,19,0,0,1,.86-3.14l1.08-3c.75-2,1.49-4,2.26-6.05l1.16-3c.4-1,.79-2,1.21-3-.32,1-.66,2.05-1,3.07l-1,3.06c-.7,2-1.44,4-2.16,6.08a50.56,50.56,0,0,0-2,6.09,21.06,21.06,0,0,0-.46,3.17A19.23,19.23,0,0,0,408.68,262.14Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.67,270a10,10,0,0,1,1.41-.83c.5-.23,1-.45,1.53-.63a15.91,15.91,0,0,1,3.2-.78,16.55,16.55,0,0,1,3.3-.13c.55,0,1.09.1,1.63.16s1.08.2,1.61.32c-1.09-.06-2.17-.15-3.25-.12a24.66,24.66,0,0,0-3.22.24,24.29,24.29,0,0,0-3.16.66A18.55,18.55,0,0,0,410.67,270Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.75,281.22a51.9,51.9,0,0,1,3.41,4c1.07,1.4,2.11,2.82,3,4.32a48.41,48.41,0,0,1-3.41-4A50.71,50.71,0,0,1,409.75,281.22Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.37 291.6 411.32 293.67 410.96 294.04 410.28 294.73 409.94 295.06 409.34 295.68 409.22 295.81 409.1 296.09 406.43 302.86 400.33 291.9 403.93 289.72 404.17 289.57 404.29 289.4 405.21 288.12 405.57 287.62 408.54 283.46 413.37 291.6",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.56,291.77l-.39.26a17.09,17.09,0,0,1-1.24-2.31l.24-.15.12-.17A20.29,20.29,0,0,0,405.56,291.77Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.34,295.68l-.12.13-.12.28a11.84,11.84,0,0,1-2.15-2l.36-.29A11.08,11.08,0,0,0,409.34,295.68Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.69,
    cy: 292.3,
    r: 0.66,
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407,
    cy: 293.72,
    r: 0.66,
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.56,291.59a10.59,10.59,0,0,0,2.72,3.14l-.34.34c-2.21-1.37-4.35-6.08-4.73-6.95l.36-.5c2.13,4.58,5.27,5.87,5.75,6.05L411,294A9,9,0,0,1,407.56,291.59Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.55,283.46a39,39,0,0,0,4.8.78c.8.1,1.61.16,2.41.25l2.42.16c3.24.18,6.48.19,9.71.09s6.48-.29,9.71-.54c1.61-.13,3.22-.3,4.84-.45l4.83-.55c-1.6.27-3.2.52-4.8.78s-3.23.41-4.84.59l-2.43.22c-.8.08-1.61.14-2.42.19l-2.44.14c-.81.05-1.62.06-2.43.09a96.09,96.09,0,0,1-9.75-.2l-2.43-.23c-.8-.1-1.61-.18-2.41-.31A35.17,35.17,0,0,1,364.55,283.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.11,
    cy: 282.48,
    r: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.17,287.9c.88,1.36,1.71,2.76,2.53,4.15s1.63,2.81,2.42,4.22,1.57,2.84,2.33,4.28l1.12,2.15c.37.73.74,1.45,1.09,2.18-.44-.68-.86-1.38-1.29-2.07l-1.24-2.09c-.83-1.39-1.63-2.8-2.42-4.22s-1.57-2.83-2.32-4.27S398.88,289.36,398.17,287.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.38,287.3a26.65,26.65,0,0,1-1.19,4.48,42.14,42.14,0,0,1-1.78,4.29,44.58,44.58,0,0,1-2.25,4.06c-.4.66-.85,1.29-1.28,1.93s-.91,1.25-1.39,1.86c.8-1.33,1.61-2.63,2.36-4l.56-1,.53-1c.37-.68.7-1.37,1-2.06q1-2.07,1.87-4.21c.29-.71.56-1.43.81-2.15S366.17,288,366.38,287.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,312.58c.12,4,.18,8,.24,12l.13,12v12l0,6-.09,6-.14-6-.1-6-.13-12v-12C383,320.59,383,316.59,383.11,312.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.1,447.68c0,.11-.07.23-.1.33a1.39,1.39,0,0,1-.36.56c-1,1-5.34,4.81-8.79,4.4h-7.4a.83.83,0,0,1-.8-.58c-.3-1-.46-3,2.28-5.25a67,67,0,0,0,6.53-9.08s4.23-1.33,7,1.23h1.76S372.82,444.91,372.1,447.68Z",
    fill: "#243E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.33,441a6.9,6.9,0,0,1,1.57-.21,7.73,7.73,0,0,1,1.59.1,6,6,0,0,1,1.55.44,3.37,3.37,0,0,1,1.29.94,6.5,6.5,0,0,0-1.42-.6,12.75,12.75,0,0,0-1.49-.32C364.41,441.2,363.38,441.13,362.33,441Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.46,443.4a7.06,7.06,0,0,1,1.58-.21,8.49,8.49,0,0,1,1.59.09,7.18,7.18,0,0,1,1.55.44,3.58,3.58,0,0,1,1.29.95,6.72,6.72,0,0,0-1.42-.6,11,11,0,0,0-1.49-.32C362.54,443.58,361.52,443.52,360.46,443.4Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.37,447.67a3.18,3.18,0,0,0,.1.33,1.35,1.35,0,0,0,.36.55c1,1,5.33,4.82,8.79,4.41H413a.83.83,0,0,0,.8-.58c.3-1,.46-3-2.28-5.25a67,67,0,0,1-6.53-9.08s-4.23-1.33-7,1.23h-1.76S395.65,444.9,396.37,447.67Z",
    fill: "#243E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.75,450.1l3,2.54a10.58,10.58,0,0,0,4.71,1.52h8.31c1.73,0,1-1.78,1-1.78a.83.83,0,0,1-.8.58h-7.4c-3.46.41-7.76-3.43-8.79-4.41a1.35,1.35,0,0,1-.36-.55,3.18,3.18,0,0,1-.1-.33A2.4,2.4,0,0,0,396.75,450.1Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.14,441c-1.05.12-2.08.18-3.09.35a10.67,10.67,0,0,0-1.49.32,6.5,6.5,0,0,0-1.42.6,3.37,3.37,0,0,1,1.29-.94,6.41,6.41,0,0,1,1.55-.45,8.49,8.49,0,0,1,1.59-.09A6.9,6.9,0,0,1,406.14,441Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,443.39c-1.06.11-2.09.18-3.1.35a11,11,0,0,0-1.49.32,7,7,0,0,0-1.42.59,3.47,3.47,0,0,1,1.29-.94,6.52,6.52,0,0,1,1.55-.44,8.49,8.49,0,0,1,1.59-.09A7.06,7.06,0,0,1,408,443.39Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.94,
    y: 243.8,
    width: 28.35,
    height: 35.97,
    rx: 2.9,
    transform: "translate(-41.98 75.54) rotate(-10.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.15,
    y: 245.35,
    width: 25.75,
    height: 0.47,
    transform: "translate(-39.32 75.41) rotate(-10.81)",
    fill: "#243E59"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 379.52,
    cy: 249.57,
    rx: 3.56,
    ry: 1.7,
    transform: "translate(-53.44 112.21) rotate(-15.73)",
    fill: "#243E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.62,215.05c-3.72,7-12.39,4.12-12.39,4.12V213.3Z",
    fill: "#f9aac0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.14,199.28c0,6.12-2.12,11.52-5.36,14.75a9.88,9.88,0,0,1-7,3.14,9.68,9.68,0,0,1-6.56-2.74c-3.47-3.16-5.78-8.77-5.78-15.15,0-9.88,5.52-17.89,12.34-17.89S396.14,189.4,396.14,199.28Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 372.02,
    cy: 200.23,
    rx: 2.86,
    ry: 3.94,
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.91,197.58s7-3.49,11.23-9.1c0,0-1.35,4-3.58,5.42,0,0,6.68-1.36,8-9.4,0,0,6.2.1,7.36,9L394,209.28l5.33-4.53L393,181.39l-11.33-2.12-12.47,11Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.07,194.28c1-.73,2-1.5,2.95-2.28s1.9-1.6,2.8-2.45,1.8-1.7,2.66-2.6,1.69-1.81,2.54-2.74c-.35.52-.71,1-1.08,1.54s-.78,1-1.19,1.45a31.66,31.66,0,0,1-2.61,2.7,31.33,31.33,0,0,1-2.9,2.38c-.51.37-1,.72-1.55,1.06S371.63,194,371.07,194.28Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.79,184.79a5.9,5.9,0,0,1-.68,1.58A6,6,0,0,1,382,187.7a5.44,5.44,0,0,1,.68-1.58A6,6,0,0,1,383.79,184.79Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.44,183.53a6.76,6.76,0,0,1,1.62.56,8.86,8.86,0,0,1,1.45.92,9.13,9.13,0,0,1,2.25,2.62,11.12,11.12,0,0,1,1.16,3.24c.12.56.15,1.14.22,1.7s0,1.14,0,1.71c-.09-.57-.14-1.13-.22-1.68s-.18-1.11-.34-1.65a13.91,13.91,0,0,0-.52-1.58,12.14,12.14,0,0,0-.7-1.51,10.87,10.87,0,0,0-2.07-2.57A9.34,9.34,0,0,0,387.44,183.53Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.6,184.5a22.06,22.06,0,0,1,0-6.49,22.06,22.06,0,0,1,0,6.49Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.05,270.57l8.29-1.34a1.67,1.67,0,0,0,1.28-1,13,13,0,0,1,4-5.23s6.15-4.15,7.26-2.55c0,0,.56.56-2.31,2.47l-2.47,2.4s4.47-.48,6.7-1.76c0,0,4.07-3.27,5.43-2.47,0,0,1.11.64-2,2.79l-3.07,2.46a.1.1,0,0,0,.1.18l4.38-1.66a21.42,21.42,0,0,0,2-.9c1-.51,2.54-1,3-.16,0,0,.56.81-.95,1.52,0,0,1.75.72.16,2,0,0-3.12,2.3-3.91,2.67,0,0,2,.05,1.19,1.56,0,0-1.59,1.6-7.66,2.79l-9.37,1.84a4.09,4.09,0,0,0-1,.32l-8.53,3.93Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.81 270.12 366.82 279.4 369.67 278.09 368 269.61 364.81 270.12",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.81,281.25l-3-11.64-4.63-.95.72,11.83s1.35,2.15,1.43,2.39a17.6,17.6,0,0,0,3.08,1Z",
    fill: "#243E59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.8,283.2c-.3-1-.55-2-.8-3s-.46-2-.67-3-.4-2-.57-3l-.24-1.52c-.07-.51-.15-1-.2-1.53.16.49.28,1,.42,1.49l.38,1.49c.25,1,.46,2,.67,3s.4,2,.57,3S361.69,282.18,361.8,283.2Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.4,270a9.14,9.14,0,0,1-3.78.69,8.08,8.08,0,0,1-1.91-.37,12.9,12.9,0,0,0-1.83-.37,23.86,23.86,0,0,0-3.78-.15,13.24,13.24,0,0,0-1.87.22,9.24,9.24,0,0,0-1.83.51,9.24,9.24,0,0,1,3.68-1.09,17.7,17.7,0,0,1,3.85,0,13.37,13.37,0,0,1,1.9.41c.31.09.62.2.91.27a9.12,9.12,0,0,0,.91.17,8.45,8.45,0,0,0,1.88,0A12,12,0,0,0,361.4,270Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.63,267.32a18.6,18.6,0,0,1,4,.78,13.22,13.22,0,0,1,1.89.74,5.08,5.08,0,0,1,1.68,1.15,9,9,0,0,0-1.82-.81c-.63-.22-1.26-.44-1.9-.63C350.18,268.15,348.9,267.78,347.63,267.32Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.52,
    cy: 274.07,
    r: 2.71,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.72,265.33a12.23,12.23,0,0,1-7.36,3.33,24,24,0,0,1,7.36-3.33Z",
    fill: "#f9aac0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,270a3.87,3.87,0,0,1-3.9,1.27A5,5,0,0,1,390,270Z",
    fill: "#f9aac0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.21,200.6a18.47,18.47,0,0,1-.73,5l-.1-.31A14.52,14.52,0,0,1,384,207.2a14.38,14.38,0,0,1-2.16-1.51,18.44,18.44,0,0,1,1.41-5.09Z",
    fill: "#f9aac0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 377.38,
    cy: 199.38,
    rx: 0.8,
    ry: 1.22,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.15,
    cy: 199.38,
    rx: 0.8,
    ry: 1.22,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.71,196.35a31.8,31.8,0,0,1,5.41-.09.49.49,0,0,0,.54-.33c.19-.58.15-1.51-2.28-1.29A6.64,6.64,0,0,0,373.71,196.35Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,196.35a31.8,31.8,0,0,0-5.41-.09.51.51,0,0,1-.55-.33c-.19-.58-.15-1.51,2.28-1.29A6.66,6.66,0,0,1,394,196.35Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.73,209.13h8.2a4.16,4.16,0,0,1-3,2.75,4.37,4.37,0,0,1-2,0A4.26,4.26,0,0,1,379.73,209.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,199a4,4,0,0,0,.25,3.39A2.09,2.09,0,0,1,371,199Z",
    fill: "#f9aac0"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M545.58,237.91h-90a1.7,1.7,0,1,1,0-3.39h90a1.7,1.7,0,1,1,0,3.39Z",
    fill: "#fddfd2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M596.94,188.75h-90a1.7,1.7,0,1,1,0-3.39h90a1.7,1.7,0,1,1,0,3.39Z",
    fill: "#fddfd2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M596.94,205.82H455.57a1.7,1.7,0,0,1,0-3.4H596.94a1.7,1.7,0,0,1,0,3.4Z",
    fill: "#fddfd2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M596.94,222.88H455.57a1.7,1.7,0,1,1,0-3.39H596.94a1.7,1.7,0,1,1,0,3.39Z",
    fill: "#fddfd2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 562.13,
    cy: 236.21,
    r: 3.1,
    fill: "#fddfd2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 576.48,
    cy: 236.21,
    r: 3.1,
    fill: "#fddfd2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 590.97,
    cy: 236.21,
    r: 3.1,
    fill: "#fddfd2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M545.58,319.16h-90a1.7,1.7,0,1,1,0-3.39h90a1.7,1.7,0,1,1,0,3.39Z",
    fill: "#fddfd2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M596.94,270h-90a1.7,1.7,0,1,1,0-3.39h90a1.7,1.7,0,1,1,0,3.39Z",
    fill: "#fddfd2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M596.94,287.07H455.57a1.7,1.7,0,1,1,0-3.39H596.94a1.7,1.7,0,1,1,0,3.39Z",
    fill: "#fddfd2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M596.94,304.14H455.57a1.7,1.7,0,0,1,0-3.4H596.94a1.7,1.7,0,0,1,0,3.4Z",
    fill: "#fddfd2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.13,
    cy: 317.47,
    r: 3.1,
    fill: "#fddfd2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 576.48,
    cy: 317.47,
    r: 3.1,
    fill: "#fddfd2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 590.97,
    cy: 317.47,
    r: 3.1,
    fill: "#fddfd2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M551.93,378.31H334.27a1.7,1.7,0,0,1,0-3.39H551.93a1.7,1.7,0,1,1,0,3.39Z",
    fill: "#fddfd2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M594.07,346.22H334.27a1.7,1.7,0,0,1,0-3.4h259.8a1.7,1.7,0,0,1,0,3.4Z",
    fill: "#fddfd2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M594.07,363.28H334.27a1.7,1.7,0,0,1,0-3.39h259.8a1.7,1.7,0,0,1,0,3.39Z",
    fill: "#fddfd2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.13,
    cy: 376.61,
    r: 3.1,
    fill: "#fddfd2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 576.48,
    cy: 376.61,
    r: 3.1,
    fill: "#fddfd2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 590.97,
    cy: 376.61,
    r: 3.1,
    fill: "#fddfd2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M555,514.93H337.33a1.7,1.7,0,1,1,0-3.39H555a1.7,1.7,0,1,1,0,3.39Z",
    fill: "#fddfd2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M597.12,482.84H337.33a1.7,1.7,0,0,1,0-3.4H597.12a1.7,1.7,0,1,1,0,3.4Z",
    fill: "#fddfd2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M597.12,464.51H373.54a1.7,1.7,0,1,1,0-3.39H597.12a1.7,1.7,0,1,1,0,3.39Z",
    fill: "#fddfd2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M597.12,499.9H337.33a1.7,1.7,0,1,1,0-3.39H597.12a1.7,1.7,0,1,1,0,3.39Z",
    fill: "#fddfd2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 565.19,
    cy: 513.23,
    r: 3.1,
    fill: "#fddfd2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 579.54,
    cy: 513.23,
    r: 3.1,
    fill: "#fddfd2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.02,
    cy: 559.1,
    r: 3.1,
    fill: "#fddfd2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 576.37,
    cy: 559.1,
    r: 3.1,
    fill: "#fddfd2"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 590.85,
    cy: 559.1,
    r: 3.1,
    fill: "#fddfd2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M551.93,437.46H334.27a1.7,1.7,0,0,1,0-3.4H551.93a1.7,1.7,0,1,1,0,3.4Z",
    fill: "#fddfd2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M594.07,405.36H373.54a1.7,1.7,0,1,1,0-3.39H594.07a1.7,1.7,0,0,1,0,3.39Z",
    fill: "#fddfd2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M594.07,422.43H334.27a1.7,1.7,0,0,1,0-3.4h259.8a1.7,1.7,0,0,1,0,3.4Z",
    fill: "#fddfd2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 562.13,
    cy: 435.76,
    r: 3.1,
    fill: "#fddfd2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 576.48,
    cy: 435.76,
    r: 3.1,
    fill: "#fddfd2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 590.97,
    cy: 435.76,
    r: 3.1,
    fill: "#fddfd2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M597.12,544.5H459.93a1.7,1.7,0,0,1,0-3.39H597.12a1.7,1.7,0,1,1,0,3.39Z",
    fill: "#fddfd2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M551.93,560.79h-127a1.7,1.7,0,0,1,0-3.39h127a1.7,1.7,0,1,1,0,3.39Z",
    fill: "#fddfd2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 397.84,
    y: 119.7,
    width: 139.36,
    height: 12.73,
    fill: "#231f20"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M527.53,84.37H487.81c0-.43.05-.87.05-1.31a20.51,20.51,0,0,0-41,0c0,.44,0,.88.05,1.31H407.51A9.67,9.67,0,0,0,397.84,94V119.5H537.2V94A9.67,9.67,0,0,0,527.53,84.37Zm-60.18,9.46a10.77,10.77,0,1,1,10.76-10.77A10.77,10.77,0,0,1,467.35,93.83Z",
    fill: "#272727"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M295.38,308.07s2,16.86-11.24,19.95l1.68,22.48s2.54,9.95,1.41,13.26A64.16,64.16,0,0,0,265,366.39a83.29,83.29,0,0,1-9.85,2.43c-10.78,1.93-33.53,5.4-51.11,4.16V310H199s2,13.77-10.68,18.27c0,0-18,3.36-14.32-23.32l14.78-62.52s1.87-15,15.18-15.57l21.72-7,23.85-.2,28.15,11.07s16,3.66,16,20.8C293.69,251.6,296.79,281.1,295.38,308.07Z",
    fill: "#EC1C24"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 594.02,
    cy: 513.23,
    r: 3.1,
    fill: "#fddfd2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M263.86,188.69c0,13.28-6,24.49-14.25,28a3,3,0,0,1-.36.16,13.82,13.82,0,0,1-5.13,1c-6.91,0-13-5.24-16.51-13.18a36.37,36.37,0,0,1-2.15-6.42,42,42,0,0,1-1.08-9.55c0-16.1,8.84-29.16,19.74-29.16S263.86,172.59,263.86,188.69Z",
    fill: "#ffb8ca"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M222.77,185s2.52.39,3.49,1.36c0,0,2.13-7,8.34-9.89,0,0,8.45-4.2,7.36-10.38a16.21,16.21,0,0,0,8.43,4.43,17.56,17.56,0,0,1,8.38,3.54,18.76,18.76,0,0,1,3.74,4s4.34,12.49-2.38,27.65c0,0-3.39,7.81-10.87,11.09l.27,2.9L260,223.84a68.77,68.77,0,0,0,7-11.48s-2.92,9.07-5.25,12.17l2.13.82s13.59-19.78,8-46.93c0,0-7.95-32.77-34.33-26.17,0,0-16.09-1.17-21.71,14.73,0,0-3.11,11.44-8.15,16.1,0,0-21.91,18.62-3.68,43.83l1.61-.52s-13.83-16.55-1-34.2c0,0-8.94,19.24,2.3,33.79l18.84-6.06Z",
    fill: "#272727"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M249.27,216.78c0-.1-.22-.27,0-.27Z",
    fill: "#ffb8ca"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M249.65,224c-1,9.28-10.78,8.68-10.78,8.68-11.83.18-13.19-12.79-13.19-12.79L223.85,198l1.46.11.16.09a35.45,35.45,0,0,0,2.14,6.41h0c3.53,7.94,9.61,13.18,16.52,13.18a13.86,13.86,0,0,0,5.13-1s0,0,0,0l0,.3.22,2.61A17.24,17.24,0,0,1,249.65,224Z",
    fill: "#ffb8ca"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M249.65,224c-3.73.47-19.77,1.28-22-19.39h0c3.53,7.94,9.61,13.18,16.52,13.18a13.86,13.86,0,0,0,5.13-1l.05.28.22,2.61A17.24,17.24,0,0,1,249.65,224Z",
    fill: "#f9aac0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.6,283.42c.12-2.57.38-5,.73-7.53s.83-5,1.37-7.41,1.26-4.86,2.07-7.23a47.55,47.55,0,0,1,3-6.84,61.9,61.9,0,0,0-1.93,7.15c-.48,2.42-.89,4.84-1.17,7.28s-.5,4.88-.65,7.32-.26,4.92-.27,7.31Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.48,305.83c-2.06-2.41-3.77-4.89-5.58-7.3-.91-1.19-1.8-2.4-2.74-3.57s-1.93-2.29-3-3.46a12.06,12.06,0,0,1,4.13,2.36,20.84,20.84,0,0,1,3.23,3.48,24.74,24.74,0,0,1,2.43,4A18.06,18.06,0,0,1,295.48,305.83Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276,321.84a9.25,9.25,0,0,1-3.13-2.69,22,22,0,0,1-2.22-3.4,24.85,24.85,0,0,1-1.6-3.71,18,18,0,0,1-.93-4,24,24,0,0,1,2.34,3.31c.69,1.13,1.35,2.27,2,3.43s1.19,2.33,1.77,3.5S275.29,320.67,276,321.84Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.79,250.75a59.39,59.39,0,0,1,2,7.75,57.76,57.76,0,0,1,1,7.87l-2,.24a54.71,54.71,0,0,1-.94-7.87A57.61,57.61,0,0,1,194.79,250.75Z"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M261.13,321.76a.42.42,0,0,1-.25.09Z",
    fill: "none",
    stroke: "#ed1c24",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M261.13,321.76l-.25.09H206a.42.42,0,0,1-.34-.19l-36.79-53.11a.42.42,0,0,1,.35-.66h56.57a.42.42,0,0,1,.35.19l35.13,53.11A.43.43,0,0,1,261.13,321.76Z",
    fill: "#243E59"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M262.9,321.15l-1.77.61a.43.43,0,0,0,.1-.57L226.1,268.08a.42.42,0,0,0-.35-.19H169.18l2-2a3,3,0,0,1,2.06-.85h52.59a3.28,3.28,0,0,1,2.75,1.5l34.69,53.54A.7.7,0,0,1,262.9,321.15Z",
    fill: "#272727"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M265.63,479.25s23.95-89.53,21.6-115.49A64.16,64.16,0,0,0,265,366.39a83.29,83.29,0,0,1-9.85,2.43c-10.78,1.93-33.53,5.4-51.11,4.16,0,0-27,78.62-29.31,102.76,0,0-3.08,16,4.19,22.47l49,48.91-2.5,33.21a26,26,0,0,0,23.86,3.78s1.57-6.33,3.76-16A89.9,89.9,0,0,0,272.31,548s-4.84-5.84-12.05-14C264.45,511.86,267.78,488.73,265.63,479.25Zm-55.27,6.25L229.84,432s4.66,26.76,1.75,67.19l-.3,4C223.67,495.71,216.26,489.22,210.36,485.5Z",
    fill: "#272727"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M229.84,432l2.7-36.36-.16,66.52S231.3,438.47,229.84,432Z",
    fill: "#231f20"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M228,547.12l24.44,24,.68-2.94s12.13-9.46,19.21-20.12c0,0-17.28,18.42-22.17,18.42Z",
    fill: "#231f20"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M210.36,485.5s42.89,40.41,49.9,48.5C260.26,534,226.06,495.1,210.36,485.5Z",
    fill: "#231f20"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M258.81,563.53l8.25,9.54s1.73-1,6.34-1.68a7.35,7.35,0,0,0,5.59-4c1.33-2.79,2.12-7.4-.08-14.65l-7.46-3.42Z",
    fill: "#ffb8ca"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M282.31,619.19a27.14,27.14,0,0,0,4.36-6.71,36.92,36.92,0,0,0,2.68-7.51,51.53,51.53,0,0,0,1.3-15.85l-.11-2-.23-2q-.21-2-.39-4c-.22-2.69-.43-5.37-.47-8.07s-.08-5.39.12-8.08a38.73,38.73,0,0,1,.51-4,14.73,14.73,0,0,1,1.2-3.85,24,24,0,0,0-1.22,7.89c-.1,2.68,0,5.36.15,8s.35,5.35.62,8c.13,1.34.28,2.67.43,4l.25,2,.13,2,.11,2,0,2c0,.67,0,1.35,0,2l-.16,2c-.07,1.36-.34,2.69-.52,4s-.52,2.66-.91,4a36.82,36.82,0,0,1-3,7.53A25.33,25.33,0,0,1,282.31,619.19Z",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M268.78,581.16a4.34,4.34,0,0,1,1.58-2.15,9.1,9.1,0,0,1,2.33-1.32,12.73,12.73,0,0,1,2.56-.68,11.56,11.56,0,0,1,2.63-.08c-.83.33-1.64.58-2.45.84s-1.61.53-2.38.85a16.4,16.4,0,0,0-2.25,1A7.86,7.86,0,0,0,268.78,581.16Z",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M270.47,585.51a9.58,9.58,0,0,1,1.59-1.77,12.58,12.58,0,0,1,1.92-1.4,10.26,10.26,0,0,1,2.2-1,5.69,5.69,0,0,1,2.39-.22,28.28,28.28,0,0,0-4.08,2.05C273.17,584,271.89,584.78,270.47,585.51Z",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M272.78,590.14a6.6,6.6,0,0,1,1.37-1.82A10.55,10.55,0,0,1,276,587a11.62,11.62,0,0,1,4.29-1.46,41.63,41.63,0,0,1-3.79,2.33c-.64.35-1.25.72-1.87,1.1S273.44,589.77,272.78,590.14Z",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M274.52,593.41a6,6,0,0,1,1.51-1.78,12.58,12.58,0,0,1,1.92-1.32,12.32,12.32,0,0,1,4.36-1.48,20.41,20.41,0,0,1-1.93,1.25c-.64.39-1.3.74-1.95,1.11C277.12,591.91,275.84,592.6,274.52,593.41Z",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M226.62,581.16l-4.77,17.35s8.29-8.44,17.74-.73l2.33-12.28S232.86,585.77,226.62,581.16Z",
    fill: "#ffb8ca"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M246.13,630.51c4-1.89,2.23-8.23.84-11.84a25.31,25.31,0,0,0-2.28-4.38,19.54,19.54,0,0,1-2.81-9.66,10.87,10.87,0,0,0-2-6c-5.6-7.91-16.41-1.45-16.41-1.45-3.76,1.94-1.64,8.9-1.64,8.9s1.15,8.31-.87,11.75a11.83,11.83,0,0,0-1.14,2.38c-1.29,3.91-2.66,13,12,13.07C231.88,633.27,240,633.4,246.13,630.51Z",
    fill: "#EC1C24"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M221,623.53c1.08.36,2.16.71,3.27,1s2.19.52,3.3.7a34.19,34.19,0,0,0,6.69.47,24.37,24.37,0,0,0,6.56-1.11l1.59-.53,1.52-.73c.26-.12.52-.22.77-.35l.72-.44q.72-.45,1.47-.87a18.26,18.26,0,0,1-5.81,3.65,20.25,20.25,0,0,1-6.79,1.38,26,26,0,0,1-6.87-.72A25.13,25.13,0,0,1,221,623.53Z",
    fill: "#fff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M228,614a8,8,0,0,1,2.7-2,8.45,8.45,0,0,1,3.33-.81,9.28,9.28,0,0,1,1.74.14,7.91,7.91,0,0,1,1.63.58A7.5,7.5,0,0,1,240,614a16.09,16.09,0,0,0-2.94-1.35,8.58,8.58,0,0,0-3.05-.44A13.88,13.88,0,0,0,228,614Z",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M227.37,608.55a10,10,0,0,1,2.6-1.37,11.22,11.22,0,0,1,2.89-.64,7.8,7.8,0,0,1,3,.31,5,5,0,0,1,2.43,1.7,8.35,8.35,0,0,0-2.62-.94,11.24,11.24,0,0,0-2.72-.07,21.82,21.82,0,0,0-2.76.39C229.25,608.12,228.33,608.33,227.37,608.55Z",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M227.37,604.18a6.5,6.5,0,0,1,2.24-1.39,7.58,7.58,0,0,1,2.63-.5,6.8,6.8,0,0,1,2.65.47,6.35,6.35,0,0,1,2.23,1.42,21.91,21.91,0,0,0-2.45-.67,10.35,10.35,0,0,0-2.41-.22A16,16,0,0,0,227.37,604.18Z",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M227.37,600.26a6.58,6.58,0,0,1,2.12-1.36,7.65,7.65,0,0,1,2.48-.61,5.91,5.91,0,0,1,2.56.4,4.52,4.52,0,0,1,2,1.57,9.79,9.79,0,0,0-2.23-.83,9.07,9.07,0,0,0-2.27-.15A22.56,22.56,0,0,0,227.37,600.26Z",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M236.79,267.89c.52-2,1.15-3.88,1.77-5.79l2.71-5.32,5.38-10.66L252,235.46l2.69-5.32c1.17-1.64,2.34-3.28,3.6-4.87-.53,2-1.16,3.87-1.78,5.78l-2.7,5.33L248.47,247l-5.39,10.66L240.4,263C239.23,264.67,238.07,266.31,236.79,267.89Z",
    fill: "#272727"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M182.62,298.66s-5.19-4.14,2.88-6.05h14.2a2.86,2.86,0,0,1,2.52,1.39,3,3,0,0,1-.37,3.3s4.91.38,3.21,4c0,0,4.34,3-.94,4.71,0,0,2.62,3.21-8.37,5.48,0,0-11.06,3-10.68-1.89,0,0-3.21-2.26-1.7-4.9C183.37,304.66,178.22,302.53,182.62,298.66Z",
    fill: "#ffb8ca"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M185.82,298.27a47.75,47.75,0,0,1,14-.8,48.09,48.09,0,0,1-14,.8Z",
    fill: "#f9aac0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M186.77,302.49a61,61,0,0,1,15.84-.85,61.4,61.4,0,0,1-15.84.85Z",
    fill: "#f9aac0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M188.46,308.07a50.24,50.24,0,0,1,14.15-2.1,49.88,49.88,0,0,1-14.15,2.1Z",
    fill: "#f9aac0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.19,
    cy: 190.58,
    rx: 5.01,
    ry: 7.65,
    transform: "translate(-25.51 34.91) rotate(-8.43)",
    fill: "#ffb8ca"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M269.24,305.83s12.87,2.57,12.87-14.33l-17-20.18s-2.7-2.51-2.66-8.07c0-.35,0-.72.05-1.09a68.45,68.45,0,0,0-.73-12.54,6.79,6.79,0,0,0-2.83-4.61l-7.35-5.1s-8.14-4.92-7.45,2.56c0,0-3.9,3.76-1.28,6.16,0,0-.65,4.58,2.4,4.8,0,0-1.74,5.67,2.62,8.29,0,0,0,6.77,4.36,8.51,0,0,7.46,8.95,11.15,19Z",
    fill: "#ffb8ca"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M248.51,258.62a6.92,6.92,0,0,1,.15-2.71,2.43,2.43,0,0,1,.83-1.25,1.9,1.9,0,0,1,1.59-.15c.23.09.46.18.68.29l.6.38,1.1.77.54.39.29.22a1.47,1.47,0,0,1,.31.35,1.65,1.65,0,0,1,0,1.8,10,10,0,0,0-1.82,4.69,4.86,4.86,0,0,0,.45,2.43,6.76,6.76,0,0,0,1.58,2.06,6,6,0,0,1-2-1.82,5,5,0,0,1-.8-2.69,9.52,9.52,0,0,1,1.76-5.21.67.67,0,0,0,0-.72c-.06-.11-.17-.18-.37-.34l-.53-.4a11.68,11.68,0,0,0-2.07-1.47,1.26,1.26,0,0,0-1,0,1.93,1.93,0,0,0-.71.86A8.51,8.51,0,0,0,248.51,258.62Z",
    fill: "#f9aac0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M257,250.75a39.78,39.78,0,0,0-6.79-.62,7.05,7.05,0,0,0-3.12.72,4,4,0,0,0-1.87,2.58,4.05,4.05,0,0,1,.27-1.77,3.63,3.63,0,0,1,1.17-1.47,6.39,6.39,0,0,1,3.51-1.06,13.13,13.13,0,0,1,3.54.4A13.7,13.7,0,0,1,257,250.75Z",
    fill: "#f9aac0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M257,246.89a37.1,37.1,0,0,1-3.81-.22c-1.25-.11-2.54-.31-3.74-.47a7.73,7.73,0,0,0-3.49.47,8,8,0,0,0-1.61.84c-.5.37-1,.76-1.53,1.12.38-.51.81-1,1.22-1.5a6.47,6.47,0,0,1,1.6-1.17,6.93,6.93,0,0,1,3.91-.75c1.31.19,2.51.42,3.76.7A37.18,37.18,0,0,1,257,246.89Z",
    fill: "#f9aac0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M244.12,242.47a2.53,2.53,0,0,1,1.2-.85,7.37,7.37,0,0,1,1.43-.38,13.53,13.53,0,0,1,2.91-.11,17.59,17.59,0,0,1,5.59,1.34c-1,0-1.91-.06-2.85-.12l-2.81-.22c-.92-.06-1.85-.12-2.77-.12a12.44,12.44,0,0,0-1.37.08A3.28,3.28,0,0,0,244.12,242.47Z",
    fill: "#f9aac0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M660.73,413a135.58,135.58,0,0,0-3.18-22.42c-1.58-6.65-3.82-13.43-8-18.92-3.84-5-9.34-9-15.7-9.79-6.15-.75-11.93,2-16.53,5.86-5.71,4.81-10.07,11.16-14.17,17.33a214.44,214.44,0,0,0-12.23,21.4.23.23,0,0,0,.14.27.2.2,0,0,0,.23-.07,133.17,133.17,0,0,1,10.93-17.92,114.46,114.46,0,0,1,12.61-15.26c4.28-4.12,9.59-8,15.69-8.16s11.7,3.21,15.37,7.91c4.1,5.25,6.18,11.8,7.75,18.18a135.53,135.53,0,0,1,3.15,21.4c1.2,14.77,1.53,29.63,1.86,44.44.19,8.39.3,16.77.39,25.16,0,4.28.07,8.49.1,12.74s-.19,48.74.48,52.8c.14.83,1.43.75,1.63,0a72.87,72.87,0,0,0,.57-11.63c0-4,.1-48.52.14-52.57.07-7.83.12-15.7.09-23.49C662,444.42,661.82,428.65,660.73,413Z",
    fill: "#272727"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M608.49,376.14c-1.58.64.57-18.07-6.81-20.47-10.42-3.37-34.25,2.74-47.55,20.47a39.91,39.91,0,0,0-5.71,11.93c6.58-3.19,28.32-13.25,33.77-10.17,5,2.86-26.19,12.59-35.78,18.87a71.34,71.34,0,0,0-.85,7.85c5.55-3.93,20.82-13.91,27.64-13.91,7.59,0-17.58,13.31-27.76,22.83a80.68,80.68,0,0,0,5.88,27.11c2.61-4.94,8.35-14.54,15.77-19.72,10.28-7.14,14.78,4.37,1.83,13.51-6.91,4.88-11.89,8.91-15,11.62a53,53,0,0,0,11.5,14.86,42.27,42.27,0,0,1,16.91-11.56c2.5-.87,6.61-2,11.54-3.67.87-3.24,3.3-12.93,3.51-19.18.29-7.61,9.31-3.38,5.64,10.13-.68,2.54-1.31,4.64-1.91,6.4,2.64-1.05,7.92-3.06,11-5.41.5-4.43-.25-14.62-2.06-24.26-2.25-12,6.86-12.85,8.83,2.25.93,7-.4,14.17-.84,18.87,10.31-6,18.85-18.21,18.85-18.21a45.73,45.73,0,0,0-7.13-18.87c-5.07-7.65.41-10.66,5.49-3.75,2.86,3.85,4.51,10.32,5.44,15.28C651.57,372.64,638.16,364.22,608.49,376.14ZM559.06,416c-2.86-4.08,6.92-11.56,9-9,2.71,3.25-6.21,13.1-9,9Zm65-16.68c-3.94,2.85-7.72-6.6-5.17-8.22S627.38,396.76,624,399.27Z",
    fill: "#008fa3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M615,393.87c-1.34-2.64-2.74-5.26-4.28-7.8a46.55,46.55,0,0,0-4.9-7.14c.43-.51.83-1,1.27-1.55.17-.22-.13-.5-.31-.3-.5.57-1,1.15-1.43,1.72a.4.4,0,0,0-.21.25c-1.83,2.19-3.56,4.45-5.2,6.76a76.85,76.85,0,0,0-8.56,2.48c-2.86,1-5.78,2-8.56,3.19-.3.11-.16.6.14.47,2.85-1.23,5.64-2.43,8.56-3.41s5.54-1.64,8.31-2.43c-.9,1.27-1.79,2.57-2.64,3.87A101,101,0,0,0,582,396.19c-5.13,2.44-10.08,5.28-15,8.13-.27.16,0,.58.27.41q7.28-4.23,14.93-7.72c4.77-2.22,9.69-4.06,14.5-6.19-12.1,18.88-19.35,40.67-29.06,60.83-.12.29.33.53.45.25,3-7.14,6.38-14,9.6-20.92l8.56-18.78c.85-1.83,1.72-3.66,2.6-5.47-.53,10.09-.31,20.34-2,30.31a.26.26,0,1,0,.5.12.24.24,0,0,0,0-.12c.7-10.77,2.6-21.4,2.53-32.21v-.14q3.06-6.18,6.59-12.13c4,9.43,8.22,19,10.09,29.14,0,.31.57.17.48-.14-2.72-10.16-5.25-20.34-10.14-29.71a113.36,113.36,0,0,1,8.56-12.29c1.34,2.51,3.07,4.88,4.59,7.28s3,4.69,4.29,7.13a103,103,0,0,1,7.57,16c.1.3.6.14.47-.14C620,404.49,617.64,399.1,615,393.87Z",
    fill: "#272727"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M694.33,420.43c-6.54-6.55-14.13-15.15-24.26-15.13-9.75,0-16.93,7.87-21,16-4.28,8.46-5.86,18.05-7.13,27.37a332.23,332.23,0,0,0-2.59,33.65c-.17,6.25-.15,12.51,0,18.76s.32,53.19,1.43,59.4c.19,1,1.81,1,1.87,0,.29-5.25.09-51,0-56.3s0-10.37.24-15.55c.39-10.49,1.14-20.95,2.37-31.4,1.09-9.1,1.93-18.46,4.65-27.26,2.47-7.93,7.07-17,15.12-20.47,11-4.77,21.67,3.92,28.85,11.26C694.2,420.89,694.53,420.67,694.33,420.43Z",
    fill: "#272727"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M733.18,442.45c-11.81-1.21-8.56-7.63,2.2-4.81a48.88,48.88,0,0,1,16,7.69c.08-9.73-1.13-19.62-4.75-28-9.86-2.47-18.84,1.87-28,6.19s-15.36-6.88-4.53-12.26a34.31,34.31,0,0,1,29.22-.52,46.81,46.81,0,0,0-2.64-4.14,49.16,49.16,0,0,0-9-10c-8.06.65-12.53,5.62-14.91,7.13-3.4,2.23-8.75-.4-5.36-5.22,2.64-3.78,9.24-5.51,14.69-6-9.72-5.7-19.41-5.7-24.9-3.23-9.52,4.28-6.85,29.42-6.85,29.42s-25-13.36-33.14-2.85A30.69,30.69,0,0,0,656,428.19c8.83-3.25,19.69-4,20.7,1.26,1.09,5.58-13.85,3.94-21.62,4.84-.92,11.19,1.69,24.26,10.59,33.5,7.59-14.58,24.45-25.68,26.86-17.62s-15.7,10.09-23.13,21a48.66,48.66,0,0,0,10.38,5.79c4.06-6.06,10.81-14.43,14.05-11.89s-5.25,8.45-10.75,13.22a157.45,157.45,0,0,0,24,6.62c2-8.4,5.85-16.27,9.56-15.54s-3.48,9.52-6.59,16.15a238.68,238.68,0,0,0,33,4.17c.69-.17,5.22-13.46,7.27-30a48.13,48.13,0,0,0-17.13-3.44c-8.35-.4-9.15-9.9,3.35-8.56a32,32,0,0,1,14.45,6q.18-2.61.3-5.34h0A47.25,47.25,0,0,0,733.18,442.45Zm-3.11-13c1.27-2.86,8.91-1.83,8.17,1.65S729,431.85,730.07,429.44ZM667.57,453c-.46-2.37,4.65-4.54,5.36-2.64s-4.72,5.81-5.36,2.64Zm35.93,19.48c-4-2.11,1.76-11.42,5.48-9.89,3,1.23-1.41,12-5.48,9.89Z",
    fill: "#008fa3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M741.68,487.83c-5.61-9.38-11.16-18.81-17-28q-4.12-6.42-8.57-12.62c.46-.08.9-.21,1.35-.31.74-.16,1.48-.31,2.22-.43,1.73-.3,3.47-.54,5.2-.73s3.28-.24,4.93-.27a25.71,25.71,0,0,1,5.26.27c.21,0,.24-.28,0-.27-1.75,0-3.54-.16-5.3-.18s-3.41,0-5.11.12-3.19.25-4.78.49c-.87.14-1.74.28-2.61.46-.51.11-1.06.18-1.57.34q-4.54-6.27-9.45-12.29a112.71,112.71,0,0,1,30.7-9.79c.19,0,.11-.31-.07-.28a104.23,104.23,0,0,0-31.14,9.44q-2.7-3.28-5.41-6.56a93.54,93.54,0,0,1-6-7.42.14.14,0,0,0-.2,0,.14.14,0,0,0,0,.2h0a109.86,109.86,0,0,1,7.13,8.7h0a108.24,108.24,0,0,0-11.41,9.17c-3.73,3.31-7.38,6.73-10.91,10.24a.14.14,0,0,0-.06.19.15.15,0,0,0,.19.07.17.17,0,0,0,.06-.06q5.24-5.2,10.92-10c3.78-3.19,7.77-6,11.58-9.16h0l2.61,3.44,1.33,1.71a.15.15,0,0,0,.09.13c1.42,1.9,2.85,3.8,4.35,5.71a45.64,45.64,0,0,0-4.28,7.82c-1.26,2.65-2.36,5.38-3.37,8.13a119.69,119.69,0,0,0-4.67,17.57c0,.19.23.27.28.09a102.35,102.35,0,0,1,5.1-17.23c1.09-2.85,2.33-5.71,3.61-8.45,1.16-2.54,2.57-5,3.67-7.55,1.26,1.69,2.5,3.36,3.74,5.06.36.48.7,1,1.06,1.42,0,.12,0,.26.11.26h0c3.85,5.38,7.52,10.89,11.09,16.45a5,5,0,0,0-.49,1.23c-.22.67-.44,1.36-.64,2a39.45,39.45,0,0,0-1,4.17c-.25,1.33-.43,2.65-.56,4a34.39,34.39,0,0,1-.33,4.53.15.15,0,0,0,.09.18.13.13,0,0,0,.18-.09.14.14,0,0,0,0-.09,14.33,14.33,0,0,1,.32-4.28c.2-1.43.47-2.85.8-4.28s.65-2.57,1-3.84c.18-.64.38-1.27.61-1.9.12-.32.27-.68.39-1q2.49,3.92,5,7.87c3.22,5.26,6.42,10.52,9.65,15.7C741.4,488.33,741.83,488.1,741.68,487.83Z",
    fill: "#272727"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M658.46,564.43c-.1-3.93-1-48.37-1.15-52.31A172.81,172.81,0,0,0,653,477.53a33.19,33.19,0,0,0-9.26-17,15,15,0,0,0-9.09-4.28,15.67,15.67,0,0,0-9.65,3,33.56,33.56,0,0,0-8.12,8.56A82.76,82.76,0,0,0,610.57,478c-.07.14.15.22.23.1a52.19,52.19,0,0,1,13.69-15.34,16,16,0,0,1,8.63-3.6,12.79,12.79,0,0,1,9,2.85c4.6,4,7,9.72,8.56,15.49,1.89,6.85,4.2,24.53,4.68,34.25.22,4.16.9,48.87,1.77,53a.69.69,0,1,0,1.34-.32Z",
    fill: "#272727"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M634,464.71c-9-.17-18.64,6.58-18.64,6.58s5.1-17.62-9.06-17.05c-8.42.34-18.92,9.16-21,22.93,3.25-1.73,10.09-5,15.49-5.14,7.34-.13,7.84,5.61-2.28,6.48a64.34,64.34,0,0,0-13.56,2.24,37.78,37.78,0,0,0,1.7,12.72c5.71-3.43,15.29-7.07,15.57-2.34.22,3.51-9.74,3.79-14.65,5a59,59,0,0,0,8.44,15,135.54,135.54,0,0,0,20.4-4.6,39,39,0,0,0-.65-7.38c-1.19-6.28,3.43-6.39,4-.35a22.06,22.06,0,0,1-.43,6.73,60.21,60.21,0,0,0,13.09-6.16,39.83,39.83,0,0,0-2.86-13.93c-1.8-4.91,1.77-7.72,4.78-2.08,1.94,3.64,1.16,10.47.52,14.27a22.15,22.15,0,0,0,4.28-4.37C648.77,479.88,643,464.91,634,464.71ZM595,468c.33-2.54,6.64-2.06,6.32-.09s-6.7,2.94-6.32.09Zm-7.05,20.69c.61-1.63,3.34-1.43,3.21-.12s-3.62,1.19-3.21.12Zm37.52,8.87c-3.67.15-2.46-7.47-.32-7.77C626.91,489.5,628.24,497.42,625.43,497.53Z",
    fill: "#008fa3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M622.16,498.22c-.36-.94-.67-1.91-1-2.86.27,1,.53,2,.7,3a.14.14,0,0,0,.18.08A.13.13,0,0,0,622.16,498.22Z",
    fill: "#263238"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M618.42,486c-.67-1.95-1.43-3.88-2.17-5.81-.4-1-.83-2-1.27-3a12.38,12.38,0,0,0-1.27-2.55,20.57,20.57,0,0,0,1.16-2.47c0-.09-.09-.14-.13-.09a30.19,30.19,0,0,0-2.77,4.29c-.38.67-.75,1.34-1.15,2a20.86,20.86,0,0,0-2.37.37c-.86.16-1.7.33-2.54.53l-2.53.58c-.83.2-1.65.47-2.51.6-.19,0-.12.34.07.27a17.23,17.23,0,0,1,2.65-.7c.82-.17,1.63-.31,2.46-.43s1.64-.22,2.47-.31l1.87-.14c-.35.58-.69,1.18-1,1.78,0,.09-.1.19-.15.29a8.11,8.11,0,0,0-2,.23c-.73.14-1.43.27-2.18.44-1.49.31-3,.67-4.41,1.07-3.07.85-6.1,1.84-9.11,2.85-.17,0-.07.32.1.26a87.94,87.94,0,0,1,9.15-2.54c1.43-.33,2.85-.66,4.35-1l2.19-.47a14,14,0,0,0,1.68-.37c-1.56,2.86-3,5.79-4.37,8.78-2.94,6.5-5.41,13.18-7.92,19.85-.07.17.19.28.25.11A180.31,180.31,0,0,1,605.35,491c.57-1.15,1.16-2.29,1.73-3.44a4.56,4.56,0,0,0,.14.7c.14.79.28,1.57.41,2.37.27,1.57.55,3.16.77,4.74a55.17,55.17,0,0,1,1.15,9.83c0,.2.31.2.28,0a48,48,0,0,1-.36-4.79c-.1-1.59-.22-3.31-.41-4.95s-.4-3.19-.66-4.77c-.12-.78-.27-1.57-.41-2.35a4.85,4.85,0,0,0-.44-1.72c.83-1.67,1.64-3.34,2.48-5s1.58-3.11,2.4-4.65c.34-.66.71-1.32,1.07-2a20.29,20.29,0,0,0,.94,2.38l1.1,2.67c.8,2,1.55,4,2.31,6,1.07,2.86,2.26,5.71,3.14,8.68C620.12,491.77,619.39,488.81,618.42,486Z",
    fill: "#272727"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M621.19,495.34a2.57,2.57,0,0,0-.2-.69A6,6,0,0,0,621.19,495.34Z",
    fill: "#263238"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "691.6 551.13 690.6 572.2 688.05 632.7 632.02 632.7 629.45 572.2 628.45 551.13 691.6 551.13",
    fill: "#a5b9c5"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "691.6 551.13 690.6 572.2 629.45 572.2 628.45 551.13 691.6 551.13",
    fill: "#d6dfe4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 624.47,
    y: 542.61,
    width: 71.11,
    height: 17.04,
    fill: "#a5b9c5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 636.56,
    y: 632.7,
    width: 9.83,
    height: 8.92,
    fill: "#a5b9c5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 636.56,
    y: 632.7,
    width: 9.83,
    height: 4.47,
    fill: "#d6dfe4"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 673.68,
    y: 632.7,
    width: 9.83,
    height: 8.92,
    fill: "#a5b9c5"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 673.68,
    y: 632.7,
    width: 9.83,
    height: 4.47,
    fill: "#d6dfe4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M235.83,179.79a13.21,13.21,0,0,1,3.29-.69,14.27,14.27,0,0,1,3.39.07,7.69,7.69,0,0,1,3.25,1.2,3.6,3.6,0,0,1,1.63,3,4.22,4.22,0,0,0-2-2.3,9.66,9.66,0,0,0-3-.87A51.64,51.64,0,0,0,235.83,179.79Z",
    fill: "#272727"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M256.12,183.33a5.09,5.09,0,0,1,1.54-.66,7.56,7.56,0,0,1,1.64-.25,4.87,4.87,0,0,1,3.19.91l-3.16.09A20.55,20.55,0,0,1,256.12,183.33Z",
    fill: "#272727"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.97,
    cy: 187.11,
    rx: 1.36,
    ry: 2.12,
    fill: "#272727"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.31,
    cy: 189.23,
    rx: 1.36,
    ry: 2.12,
    fill: "#272727"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M251.13,191.36a21.15,21.15,0,0,1,1,2c.3.67.57,1.34.83,2,.52,1.36,1,2.73,1.39,4.13l.18.63-.62,0a32.93,32.93,0,0,1-4.73-.46,34.42,34.42,0,0,1,4.73-.46l-.44.61c-.5-1.36-1-2.74-1.35-4.14-.21-.7-.39-1.4-.55-2.11S251.23,192.09,251.13,191.36Z",
    fill: "#f9aac0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M241.61,203.81l12.27,1.09a13,13,0,0,1-1.76,2.18A6.16,6.16,0,0,1,242,205,11.34,11.34,0,0,1,241.61,203.81Z",
    fill: "#fff"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M222.94,187.11a10.25,10.25,0,0,0,.91,7,4.64,4.64,0,0,1-.91-7Z",
    fill: "#f9aac0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSearch);
export default __webpack_public_path__ + "static/media/job-search.b6e3d3400dcead95613c3301ed0aa1c7.svg";
export { ForwardRef as ReactComponent };